"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Part = {
    type: "structure",
    required: [],
    members: {
        PartNumber: {
            shape: {
                type: "integer"
            }
        },
        LastModified: {
            shape: {
                type: "timestamp"
            }
        },
        ETag: {
            shape: {
                type: "string"
            }
        },
        Size: {
            shape: {
                type: "integer"
            }
        }
    }
};
//# sourceMappingURL=_Part.js.map